export default __webpack_public_path__ + "static/media/weightlossregime_1@3x.a2fbbe91.jpg";